import React from 'react';
import { connect } from 'react-redux';
import objectAssign from 'object-assign';
import WaitingAreaManageTagsContent from '../components/pages/waiting-area/manage-tags/content';
import NotFoundPage from './NotFoundPage.js';
import { isAnyOverlayFormVisible, isAnyInputFormVisible } from 'businessLogic/form';
import { closeModalsForWAManageTags } from 'actions/modal';
import { updateFetchingWA } from 'actions/waitingArea';
import { hasPermissionWA } from 'businessLogic/checkExistOrVerifyPermissions';
import FeatureUnavailablePage from './FeatureUnavailablePage.js';
@connect(mapStateToProps)
export default class WaitingAreaManageTagsPage extends React.Component {
  constructor(props) {
    super(props);
  }

  UNSAFE_componentWillMount() {
    //Set getting waiting area = {} to force fetching waiting area info
    this.props.dispatch(updateFetchingWA({}));
  }

  render() {
    // permissions check
    if (this.props.redirectToPageNotFound || !this.props.hasWaitingAreas || this.props.waExistWithPermission == false) {
      if (isAnyOverlayFormVisible() || isAnyInputFormVisible()) {
        this.props.dispatch(closeModalsForWAManageTags());
      }

      if (!this.props.subscriptionLevelIsSufficient) {
        // This means this WA exists and this user has permission to view the manage-tag page;
        // But just because reporting tags is not enabled for users in this org so user should see the subscription level page
        return <FeatureUnavailablePage dispatch={this.props.dispatch} />;
      } else {
        return <NotFoundPage dispatch={this.props.dispatch} />;
      }
    }

    return (
      <WaitingAreaManageTagsContent
        id={parseInt(this.props.match.params.id)}
        waitingArea={this.props.waitingArea}
        searchTerm={this.props.searchTerm}
        userId={this.props.userId}
        dispatch={this.props.dispatch}
        availableTags={this.props.availableTags}
        selectedTagObject={this.props.selectedTagObject}
        showRemoveTagConfirmationModal={this.props.showRemoveTagConfirmationModal}
        showEditTagValueModal={this.props.showEditTagValueModal}
        showAssignTagsModal={this.props.showAssignTagsModal}
        previousPage={this.props.previousPage}
      />
    );
  }
}

function mapStateToProps(state, props) {
  let availableTags = null;
  let selectedWaitingArea = state.waitingAreaReducer.cleanWaitingArea;
  if (!!state.waitingAreaReducer.selectedWaitingAreaId && state.waitingAreaReducer.waitingAreas.length > 0) {
    const selectedWaitingAreaId = state.waitingAreaReducer.selectedWaitingAreaId;
    selectedWaitingArea = state.waitingAreaReducer.waitingAreas.find((wa) => wa.id === selectedWaitingAreaId);

    if (!!state.waitingAreaReducer.availableTagsByWaitingAreaId) {
      if (state.waitingAreaReducer.availableTagsByWaitingAreaId.waitingAreaId === selectedWaitingAreaId)
        availableTags = state.waitingAreaReducer.availableTagsByWaitingAreaId.availableTags;
    }
  }
  const waitingArea = objectAssign({}, state.waitingAreaReducer.cleanWaitingArea, selectedWaitingArea);
  let waExistWithPermission = true;
  let subscriptionLevelIsSufficient = true;
  let networkId = props.match.params.id;

  let fetchingWaitingArea = state.waitingAreaReducer.fetchingWaitingArea;
  let canAccess = fetchingWaitingArea === false ? hasPermissionWA(state, networkId, 'VIEW_ASSIGNED_TAGS') : true;

  if (state.waitingAreaReducer.selectedWaitingAreaId && (!waitingArea.reportingTagsEnabled || !canAccess)) {
    waExistWithPermission = false;
    if (
      // Checking userProfile waiting areas status is necessary
      // During fetching the basicinfo api, waiting areas is [], so hasPermissionWA(state, networkId, 'VIEW_ASSIGNED_TAGS') will return true, making subscriptionLevelIsSufficient=false;
      // But this is incorrect, because should not returning true or false during fetching
      state.usersReducer.userProfile &&
      state.usersReducer.userProfile.waitingAreas &&
      state.usersReducer.userProfile.waitingAreas.length > 0 &&
      canAccess &&
      !waitingArea.reportingTagsEnabled
    ) {
      subscriptionLevelIsSufficient = false;
    }
  }
  return {
    redirectToPageNotFound: state.sharedReducer.redirectToPageNotFound,
    waitingArea: waitingArea,
    availableTags: availableTags,
    selectedTagObject: state.waitingAreaReducer.selectedTagObject,
    searchTerm: state.waitingAreaReducer.currentWaitingAreaTagFilter || '',
    showAssignTagsModal: state.modalReducer.showAssignTagsModal,
    hasWaitingAreas: state.usersReducer.userProfile.hasWaitingAreas,
    showRemoveTagConfirmationModal: state.modalReducer.showRemoveTagConfirmationModal,
    showEditTagValueModal: state.modalReducer.showEditTagValueModal,
    userId: state.usersReducer.userProfile.id,
    previousPage: state.navigationBarReducer.previousPage,
    waExistWithPermission,
    subscriptionLevelIsSufficient,
  };
}
